import {convertToRoman} from 'app/helpers/convertToRoman';

export const getTeamName = (name: string, level: number) => {
  return level > 1 ? `${name} ${convertToRoman(level)}` : name;
};
